export const pricing = {
  title: "Choose Your Plan",
  subtitle: "Select the perfect plan for your AI needs",
  monthly: "Monthly",
  yearly: "Yearly",
  yearlyDiscount: "25% off",
  contactUs: "Contact Us",
  getStarted: "Get Started",
  mostPopular: "Most Popular",
  currentPlan: "Current Plan",
  tiers: {
    free: {
      name: "Free",
      description: "Perfect for testing and exploring",
      price: "$0.00",
      features: [
        "Daily limits policy",
        "Access to Free Models",
        "All features available",
      ],
    },
    prepaid: {
      name: "Pre-paid",
      description: "Pay only for what you use",
      price: "$ --",
      features: [
        "Deposit Any Amount",
        "Pay Per Use",
        "Credits Never Expire",
        "No Monthly Commitment",
        "Basic Support",
        "Detailed Usage Analytics",
      ],
    },
    subscription: {
      name: "Pro",
      description: "Best value for regular users",
      price: "$20",
      yearlyPrice: "$180",
      period: "/mo",
      yearlyPeriod: "/year",
      features: [
        "All Premium Models Included",
        "No Usage Limits",
        "Priority Support",
        "Advanced Analytics",
      ],
    },
    enterprise: {
      name: "Enterprise",
      description: "Custom solutions for large teams",
      price: "Custom",
      features: [
        "API Access",
        "Custom Model Training",
        "Dedicated Support",
        "SLA Guarantees",
        "Custom Integrations",
        "Volume Discounts",
      ],
    },
  },
  secondaryTitle: "How much can you do with $5?",
  secondarySubtitle: "$ 5 are enough to create many images and videos.",
  canBeDoneWith36Credits: [
    {
      title: "Generate 1800 images 512x512",
    },
    {
      title: "Generate 13 5s videos",
    },
    {
      title: "1.4M GPT-4o tokens",
    },
    {
      title: "18 Virtual Staging tasks",
    },
    {
      title: "0.8M Claude 3.5 Sonnet tokens",
    },
    {
      title: "1200 Corporate Re-ranking tasks (Cohere)",
    },
    {
      title: "3.4M Maritaca tokens (Sabiá 3)",
    },
    {
      title: "12M DeepSeek V3 tokens",
    },
  ],
};
